var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stripe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M2.87195 7.14542C2 8.85671 2 11.0969 2 15.5773V17.9773C2 22.4578 2 24.698 2.87195 26.4093C3.63893 27.9146 4.86278 29.1384 6.36808 29.9054C8.07937 30.7773 10.3196 30.7773 14.8 30.7773H17.2C21.6804 30.7773 23.9206 30.7773 25.6319 29.9054C27.1372 29.1384 28.3611 27.9146 29.1281 26.4093C30 24.698 30 22.4578 30 17.9773V15.5773C30 11.0969 30 8.85671 29.1281 7.14542C28.3611 5.64012 27.1372 4.41628 25.6319 3.64929C23.9206 2.77734 21.6804 2.77734 17.2 2.77734H14.8C10.3196 2.77734 8.07937 2.77734 6.36808 3.64929C4.86278 4.41628 3.63893 5.64012 2.87195 7.14542Z",
    fill: "url(#paint0_linear_14058_70188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M2.26522 9.05638C2 10.5637 2 12.5636 2 15.5768V17.9768C2 22.4572 2 24.6974 2.87195 26.4087C3.63893 27.914 4.86278 29.1379 6.36808 29.9049C8.07937 30.7768 10.3196 30.7768 14.8 30.7768H17.2C21.6804 30.7768 23.9206 30.7768 25.6319 29.9049C27.1372 29.1379 28.3611 27.914 29.1281 26.4087C30 24.6974 30 22.4572 30 17.9768V15.5768C30 11.0964 30 8.85618 29.1281 7.14489C28.3878 5.69196 27.2218 4.50125 25.788 3.73047L2.26522 9.05638Z",
    fill: "url(#paint1_linear_14058_70188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    d: "M29.7103 24.6328C29.5818 25.3086 29.3961 25.8846 29.1281 26.4107C28.3611 27.916 27.1372 29.1398 25.6319 29.9068C23.9719 30.7527 21.814 30.778 17.5963 30.7787H16.0586V27.6155L29.7103 24.6328Z",
    fill: "url(#paint2_linear_14058_70188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    d: "M17.2 2.77734H14.8C13.9283 2.77734 13.1414 2.77734 12.4268 2.78376V6.74786L25.7854 3.7296C25.7346 3.7023 25.6834 3.67553 25.6319 3.64929C24.6819 3.16523 23.5688 2.94989 22 2.8541C20.7429 2.77734 19.1931 2.77734 17.2 2.77734Z",
    fill: "url(#paint3_linear_14058_70188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_5",
    d: "M30.0001 18.1509C30 21.1565 29.9946 23.1377 29.7104 24.6316L24.9624 25.669V18.5934L30.0001 17.4219V18.1509Z",
    fill: "url(#paint4_linear_14058_70188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9409 14.1533C14.9409 13.5106 15.4664 13.2634 16.3366 13.2634C17.5846 13.2634 19.1609 13.6424 20.4088 14.3181V10.4455C19.0459 9.90173 17.6995 9.6875 16.3366 9.6875C13.0033 9.6875 10.7866 11.4343 10.7866 14.351C10.7866 18.8992 17.0263 18.1741 17.0263 20.1351C17.0263 20.8932 16.3695 21.1403 15.4499 21.1403C14.0871 21.1403 12.3465 20.5801 10.9672 19.822V23.744C12.4943 24.4032 14.0378 24.6833 15.4499 24.6833C18.8653 24.6833 21.2134 22.986 21.2134 20.0363C21.197 15.1255 14.9409 15.9989 14.9409 14.1533Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14058_70188",
    x1: 2,
    y1: 2.77734,
    x2: 11.1967,
    y2: 9.27944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14058_70188",
    x1: 3.05439,
    y1: 9.35128,
    x2: 23.3566,
    y2: 26.0978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A8F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14058_70188",
    x1: 16.0586,
    y1: 27.7328,
    x2: 30,
    y2: 30.7788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61A2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58E6FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14058_70188",
    x1: 12.4268,
    y1: 4.76898,
    x2: 30,
    y2: 2.77734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6875E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14058_70188",
    x1: 24.9624,
    y1: 18.652,
    x2: 30.0001,
    y2: 24.6855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71A5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CC3FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.807c611b6ba7a8dfa98c1b5613310989.svg";
export { ForwardRef as ReactComponent };